/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Camera/view.blocks to change it.
import React from 'react'
import UploadAction from './UploadAction/index'
import VideoCapture from 'DesignSystem/VideoCapture/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Camera({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Picture/Camera",
  theme,
  preview,
  onCapture,
  onClear,
  showOverlay
  
}) {
  return (<React.Fragment
>
<VideoCapture
  viewPath={`${viewPath}/VideoCapture`}
 theme={theme}
 preview={preview}
 onCapture={onCapture}
 onClear={onClear}
 showOverlay={showOverlay}
/>
<UploadAction
  viewPath={`${viewPath}/UploadAction`}
/>
{children}
</React.Fragment>)
}